import(/* webpackMode: "eager" */ "/vercel/path0/blockpage411/app/trending/page.tsx");
